import { TextField, FormGroup } from "@mui/material";

export default function TextFieldControl(props) {
  return (
    <FormGroup style={{ paddingTop: "10", paddingBottom: "12px" }} size="small">
      <TextField
        size="small"
        variant="outlined"
        // label={props.type === "Header" ? "Header Text" : "Row Text"}
        placeholder={
          props.type === "Header"
            ? "Enter Header text here"
            : "Enter row text here"
        }
        type={"text"}
        accept="image/x-png,image/jpeg"
        // disabled={props.readOnly}
        // multiline={props.maxLength !== null && props.maxLength > 254}
        // rows={props.maxLength !== null && props.maxLength > 254 ? 4 : 1}
        inputProps={{
          maxLength: 80,
        }}
        id={props.id}
        name={props.id}
        value={props.value}
        onChange={(e) => props.onChange(props.id, e.target.value)}
        // onFocus={() => onFocus("Row Text")}
      />
    </FormGroup>
  );
}
